<div class="bg-white p-4">
    <div class="overflow-x-auto">
        <div class="">
            <div class="flex justify-between rounded-t flex flex-col mb-02 px-2 rounded-lg">
                <div class="flex items-center justify-between mb-4">
                    <div class="flex items-center space-x-2 w-auto min-w-[24rem]">
                        <!-- Department Dropdown (Hidden) -->
                        <!-- <select id="department" class="textField hidden" [ngModel]="department_id()"
                            (ngModelChange)="onDepartmentChange($event)">
                            <option value="null" hidden disabled selected>Choose a Department</option>
                            @for (dept of $$departmentDTO(); track dept.departmentId) {
                            <option [ngValue]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
                            }
                        </select> -->

                        <!-- Machine Dropdown -->
                        @if ($$departmentDTO().length > 0 && $$departmentDTO()[0].machines.length > 0) {
                        <select id="machine-dropdown" class="textField w-full" [ngModel]="selectedMachineId()"
                            (ngModelChange)="scrollToMachine($event)">
                            <option [ngValue]="null" hidden disabled>Choose a Machine</option>
                            @for (machine of $$filteredMachines(); track machine.machineId) {
                            <option [ngValue]="machine.machineId">{{ machine.machineName }}</option>
                            }
                        </select>
                        <input type="text" class="textField w-32" placeholder="Search Job..." [ngModel]="searchJobNo()"
                            (ngModelChange)="searchJobNo.set($event)" />
                        <button class="p-2 text-gray-500 hover:text-gray-700 transition-colors" (click)="get()"
                            title="Refresh">
                            <i class="fa fa-refresh"></i>
                        </button>
                        <button
                            class="px-3 py-2 text-sm font-medium rounded-lg border whitespace-nowrap transition-colors"
                            [ngClass]="isEditMode() ? 'bg-indigo-100 border-indigo-300 text-indigo-700' : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100'"
                            (click)="toggleEditMode()">
                            <i class="fa fa-arrows-alt mr-1"></i> Edit Mode
                        </button>
                        }
                        @if ((selectedMachineId() === 2 || selectedMachineId() === 9 || selectedMachineId() === 16) &&
                        canChangeStatus) {
                        <button class="button-blue whitespace-nowrap" (click)="openPendingJobsModal()">Pending
                            Jobs</button>
                        }
                        @if (canManageService) {
                        <button class="button-blue whitespace-nowrap" (click)="openAddServicesModal()">Add
                            Services</button>
                        }
                    </div>
                    <div class="flex items-center space-x-2">
                        <button (click)="toggleCustomRange()"
                            class="button-white whitespace-nowrap mr-2 border border-gray-300 shadow-sm rounded-md px-3 py-1.5 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                            {{ showCustomRange() ? 'Week View' : 'Custom Range' }}
                        </button>

                        @if (!showCustomRange()) {
                        <select [(ngModel)]="selectedYearValue" (change)="updateCalendarYear(selectedYearValue)"
                            class="textField">
                            @for (year of years; track year) {
                            <option [value]="year">{{ year }}</option>
                            }
                        </select>
                        <select [(ngModel)]="selectedMonthValue" (change)="updateCalendarMonth(selectedMonthValue)"
                            class="textField">
                            @for (month of months; track $index) {
                            <option [value]="$index">{{ month }}</option>
                            }
                        </select>
                        <button (click)="previousWeek()" class="button-blue" [disabled]="startDayIndex() === 0">
                            Previous
                        </button>
                        <button (click)="nextWeek()" class="button-blue"
                            [disabled]="startDayIndex() + 7 >= daysInCurrentMonth">
                            Next
                        </button>
                        } @else {
                        <input type="date" class="textField" [(ngModel)]="manualStartDate"
                            (ngModelChange)="onManualStartDateChange()" />
                        <span class="text-sm font-medium text-gray-500">to</span>
                        <input type="date" class="textField" [(ngModel)]="manualEndDate"
                            (ngModelChange)="onManualEndDateChange()" />
                        <button (click)="applyManualDateRange()" class="button-blue whitespace-nowrap">
                            Apply
                        </button>
                        <button (click)="downloadOperationSchedule()" class="button-blue whitespace-nowrap ml-2">
                            Download
                        </button>
                        }
                    </div>
                </div>



                <div
                    class="overflow-hidden h-[calc(100vh-140px)] flex flex-col rounded-xl border border-gray-200 shadow-sm">
                    <table class="table-fixed w-full h-full">
                        <thead class="sticky top-0 z-20 bg-gray-50 border-b">
                            <tr>
                                <th class="px-4 py-3 text-center border-x border-gray-100 transition-colors"
                                    [class.hover:bg-indigo-50]="isEditMode()" (dragover)="allowDrop($event, day)"
                                    (drop)="onDropToDateHeader($event, day)" *ngFor="let day of calendarDays">
                                    <div class="flex flex-col items-center">
                                        <span class="text-xs font-semibold text-gray-400 uppercase tracking-wider">{{
                                            day | date: 'EEE' }}</span>
                                        <span class="text-xl font-bold text-gray-800">{{ day | date: 'dd' }}</span>
                                        <span class="text-[11px] font-medium text-gray-500 whitespace-nowrap">{{
                                            getPlannedJobCountForDay(day) }} {{ getPlannedJobCountForDay(day) === 1 ?
                                            'Job' : 'Jobs' }}</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (dep of Department(); track dep) {
                            @for (machine of dep.machines; track machine) {
                            <tr class="" [id]="'machine-row-' + machine.machineId">
                                <td *ngFor="let day of calendarDays"
                                    class="align-top border-x border-gray-100 p-0 w-[14.28%] bg-white h-full"
                                    (dragover)="allowDrop($event, day)" (drop)="onDropToDay($event, day, machine)">
                                    <div
                                        class="h-full w-full p-2 overflow-y-auto space-y-2 scrollbar-hide overscroll-contain snap-y snap-proximity scroll-pt-2 relative">
                                        @if (isEditMode()) {
                                            @if (!hasContinuedJobAtStart(machine.operations, day)) {
                                                <div class="h-6 w-full rounded border border-dashed border-gray-300 hover:border-indigo-500 hover:bg-indigo-50 flex items-center justify-center transition-colors shrink-0"
                                                    (dragover)="allowDrop($event, day)"
                                                    (drop)="onDropToColumnTop($event, day, machine)">
                                                    <span
                                                        class="text-[9px] font-medium text-gray-400 uppercase tracking-wider">Drop
                                                        to start of day (00:00)</span>
                                                </div>
                                            }

                                            @if (getFreeGapAtStart(machine.operations, day); as startGap) {
                                                <div class="h-8 w-full rounded border border-dashed border-red-300 bg-red-50 flex items-center justify-between px-2 text-[10px] font-medium text-red-500 relative group shrink-0">
                                                    <span>Gap: {{ startGap.durationHours }}h</span>
                                                    <span>{{ startGap.startTime }} - {{ startGap.endTime }}</span>
                                                    @if (startGap.nextOpId && startGap.fullStartTime) {
                                                    <button class="hidden group-hover:flex absolute inset-0 bg-red-100 items-center justify-center text-red-700 rounded transition-colors cursor-pointer" (click)="removeGap(startGap.nextOpId, startGap.fullStartTime)">
                                                        Remove Gap
                                                    </button>
                                                    }
                                                </div>
                                            }
                                        }
                                        @for (operation of machine.operations; track operation) {
                                        @if (isOperationInDay(operation, day)) {
                                        <div class="p-3 rounded-md border flex flex-col justify-between min-h-[110px] cursor-pointer hover:shadow-md transition-all duration-300 snap-start relative"
                                            [attr.draggable]="isEditMode() && (operation.jobStatus === 'pending' || operation.jobStatus === 'hold') ? 'true' : 'false'"
                                            (dragstart)="onDragStart($event, operation, machine)"
                                            (dragover)="allowDrop($event, day)"
                                            (drop)="onDropToJob($event, operation, day, machine)"
                                            [class.cursor-grab]="isEditMode() && (operation.jobStatus === 'pending' || operation.jobStatus === 'hold')"
                                            [class.hover:ring-2]="isEditMode() && (operation.jobStatus === 'pending' || operation.jobStatus === 'hold')"
                                            [class.hover:ring-indigo-400]="isEditMode() && (operation.jobStatus === 'pending' || operation.jobStatus === 'hold')"
                                            [class.line-through]="operation.jobStatus === 'failed' || operation.jobStatus === 'maintenance cancelled'"
                                            [class.!bg-yellow-50]="isJobHighlighted(operation.jobNo)"
                                            [class.!border-yellow-400]="isJobHighlighted(operation.jobNo)"
                                            [class.shadow-md]="isJobHighlighted(operation.jobNo)"
                                            [class.z-30]="isJobHighlighted(operation.jobNo)" [ngClass]="{
                                'bg-green-100 border-green-300 text-green-900': operation.jobStatus === 'completed' || operation.jobStatus === 'maintenance completed',
                                'bg-blue-100 border-blue-200 text-blue-900': operation.jobStatus === 'in progress' || operation.jobStatus === 'make ready' || operation.jobStatus === 'maintenance ongoing',
                                'bg-gray-100 border-gray-300 text-gray-900': operation.jobStatus === 'pending' || operation.jobStatus === 'maintenance scheduled',
                                'bg-red-50 border-red-200 text-red-900': operation.jobStatus === 'failed' || (operation.jobStatus === 'hold' && getLastReason(operation) !== 'First pass completed') || operation.jobStatus === 'maintenance cancelled',
                                'bg-yellow-50 border-yellow-200 text-yellow-900': operation.jobStatus === 'hold' && getLastReason(operation) === 'First pass completed'
                              }" (click)="onCardClick($event, operation)">
                                            @if (isContinuedFromPreviousDay(operation, day)) {
                                            <div
                                                class="text-[9px] font-bold text-gray-500 uppercase tracking-wider mb-2 flex items-center bg-gray-200 bg-opacity-50 px-2 py-0.5 rounded w-fit">
                                                <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor"
                                                    viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                                                </svg>
                                                Continued
                                            </div>
                                            }
                                            @if (operation.jobStatus === 'failed') {
                                            <div
                                                class="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
                                                <span
                                                    class="bg-red-600 text-white font-bold text-[11px] px-2.5 py-0.5 rounded shadow-sm no-underline">FAILED</span>
                                            </div>
                                            }
                                            @if (operation.jobStatus === 'maintenance scheduled' || operation.jobStatus
                                            === 'maintenance ongoing' || operation.jobStatus === 'maintenance completed'
                                            || operation.jobStatus === 'maintenance cancelled') {
                                            <div class="flex flex-col h-full space-y-1">
                                                <span class="font-bold text-sm">
                                                    {{ operation.jobStatus === 'maintenance scheduled' ? 'Scheduled
                                                    Service' : operation.jobStatus === 'maintenance ongoing' ? 'Ongoing
                                                    Service' : operation.jobStatus === 'maintenance completed' ?
                                                    'Maintenance Completed' : 'Maintenance Cancelled' }}
                                                </span>
                                                <span class="text-xs opacity-75">{{ operation.estimatedDateTime |
                                                    date:'MMM d, HH:mm' }}</span>
                                                <span class="text-xs opacity-75">{{ formatHours(operation.estimateTime)
                                                    }}</span>
                                            </div>
                                            } @else {
                                            <div class="flex flex-col">
                                                <div class="flex justify-between items-start">
                                                    <span class="text-[12px] font-bold text-gray-900">{{ operation.jobNo
                                                        }}</span>

                                                </div>
                                                <div class="flex gap-1">
                                                    <div *ngIf="operation.isResorting === 1 || operation.isReprint === 1 || operation.isRework === 1; else normalStage"
                                                        class="bg-yellow-200 text-yellow-800 text-[10px] font-medium px-1.5 py-0.5 rounded whitespace-nowrap">
                                                        Re-{{ operation.stage }}
                                                    </div>
                                                    <ng-template #normalStage>
                                                        <div class="bg-gray-200 text-gray-800 text-[10px] font-medium px-1.5 py-0.5 rounded whitespace-nowrap">
                                                            {{ operation.stage }}
                                                        </div>
                                                    </ng-template>
                                                    <div *ngIf="operation.jobPassNumber > 1"
                                                        class="bg-yellow-200 text-yellow-800 text-[10px] font-medium px-1.5 py-0.5 rounded whitespace-nowrap">
                                                        {{ operation.jobPassNumber }} Pass
                                                    </div>
                                                </div>
                                                <span
                                                    class="text-[13px] font-medium text-gray-800 truncate mt-1 leading-tight">{{
                                                    operation.customer }}</span>
                                                <span class="text-[11px] text-gray-500 truncate mt-1">{{
                                                    operation.jobDescription }}</span>
                                            </div>
                                            <div class="flex justify-between items-center mt-2">
                                                <span class="text-[11px] text-gray-500">Planned - {{
                                                    getPlannedQuantityForDay(operation, day) }}</span>
                                                <span class="text-[11px] text-gray-500">{{ operation.estimateTime }}
                                                    h</span>
                                            </div>
                                            }
                                            @if (isContinuingToNextDay(operation, day)) {
                                            <div
                                                class="text-[9px] font-bold text-gray-500 uppercase tracking-wider mt-2 flex items-center justify-end bg-gray-200 bg-opacity-50 px-2 py-0.5 rounded w-fit ml-auto">
                                                Continues
                                                <svg class="w-3 h-3 ml-1" fill="none" stroke="currentColor"
                                                    viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                                                </svg>
                                            </div>
                                            }
                                        </div>
                                        @if (isEditMode()) {
                                            @if (getFreeGapAfterOp(operation, machine.operations, day); as gap) {
                                                <div class="h-8 w-full rounded border border-dashed border-red-300 bg-red-50 flex items-center justify-between px-2 text-[10px] font-medium text-red-500 relative group shrink-0">
                                                    <span>Gap: {{ gap.durationHours }}h</span>
                                                    <span>{{ gap.startTime }} - {{ gap.endTime }}</span>
                                                    @if (gap.nextOpId && gap.fullStartTime) {
                                                    <button class="hidden group-hover:flex absolute inset-0 bg-red-100 items-center justify-center text-red-700 rounded transition-colors cursor-pointer" (click)="removeGap(gap.nextOpId, gap.fullStartTime)">
                                                        Remove Gap
                                                    </button>
                                                    }
                                                </div>
                                            }
                                        }
                                        }
                                        }
                                    </div>
                                </td>
                            </tr>
                            }
                            }
                        </tbody>
                        <tfoot class="sticky bottom-0 z-20 bg-white border-t">
                            <tr>
                                <td class="px-2 py-3 border-x border-gray-100 align-top text-left"
                                    *ngFor="let day of calendarDays">
                                    <div class="flex flex-col gap-1">
                                        <span
                                            class="text-[12px] font-medium text-gray-500 whitespace-nowrap overflow-hidden text-ellipsis">Total
                                            {{ getTotalQuantityForDay(day) }}</span>
                                        @if (getRemainingTimeForDay(day)) {
                                        <span class="text-[11px] font-bold text-green-600 whitespace-nowrap">Rem: {{
                                            getRemainingTimeForDay(day) }}</span>
                                        }
                                        @if (getOvertimeSuggested(day)) {
                                        <span class="text-[11px] font-bold text-yellow-500 whitespace-nowrap">OT: {{
                                            getOvertimeSuggested(day) }}</span>
                                        }
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

@if(modal.$$openOpeartion()){
<div id="operation-modal" tabindex="-1" aria-hidden="true"
    class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
    <div class="relative p-4 w-full max-w-5xl mx-auto bg-white rounded-lg shadow-lg max-h-80vh overflow-y-auto">
        <div class="relative">
            <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    <span>Job Operation Details {{ GetJobOperationDTO()[0].job_details.jobNo }}</span>
                    @if (
                    GetJobOperationDTO()[0].isResorting === 1 ||
                    GetJobOperationDTO()[0].isReprint === 1 ||
                    GetJobOperationDTO()[0].isRework === 1
                    ) {
                    <span
                        class="ml-2 bg-yellow-500 text-white text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
                        Re-{{ GetJobOperationDTO()[0].stage }} {{ GetJobOperationDTO()[0].remarks }}
                    </span>
                    }
                </h3>
                <button type="button" (click)="closeOperationModal()"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                    data-modal-toggle="crud-modal">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <div class="pt-4">
                <div class="flex flex-row gap-4">
                    <div class="mb-6 p-6 bg-gray-50 shadow rounded-lg w-1/2"
                        [ngClass]="showOperationReschedule() ? 'w-1/2' : 'w-full'">
                        <div class="grid grid-cols-1 gap-4">
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Machine Name</span>
                                <span class="text-gray-700 text-sm w-1/2">{{
                                    GetJobOperationDTO()[0].machine_details.machineName
                                    }}</span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Job Name</span>
                                <span class="text-gray-700 text-sm w-1/2">{{
                                    GetJobOperationDTO()[0].job_details.jobDescription
                                    }}</span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Estimate Date and Time</span>
                                <span class="text-gray-700 text-smw-1/2">{{ GetJobOperationDTO()[0].estimatedDateTime |
                                    date:'yyyy-MM-dd
                                    HH:mm' }}</span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Estimate Duration</span>
                                <span class="text-gray-700 text-sm w-1/2">{{
                                    formatHours(GetJobOperationDTO()[0].estimateTime) }}</span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Customer</span>
                                <span class="text-gray-700 text-sm w-1/2">{{
                                    GetJobOperationDTO()[0].job_details.customer }}</span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Start Date</span>
                                <span class="text-gray-700 text-sm w-1/2">{{
                                    formatNewDateTime(GetJobOperationDTO()[0].startedDateTime)
                                    }}</span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Completed Date and Time</span>
                                <span class="text-gray-700 text-sm w-1/2">{{
                                    formatNewDateTime(GetJobOperationDTO()[0].completedDateTime) }}</span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Operation Status</span>
                                <span class="text-gray-700 text-sm w-1/2">{{ GetJobOperationDTO()[0].jobStatus |
                                    uppercase }}</span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Duration</span>
                                <span class="text-gray-700 text-sm w-1/2">
                                    {{ getDuration(GetJobOperationDTO()[0].startedDateTime,
                                    GetJobOperationDTO()[0].completedDateTime) }}
                                </span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Job Quantity</span>
                                <span class="text-gray-700 text-sm w-1/2">{{
                                    GetJobOperationDTO()[0].job_details.jobQuantity | number
                                    }}</span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Planned Impressions</span>
                                <span class="text-gray-700 text-sm w-1/2">{{ GetJobOperationDTO()[0].quantity | number
                                    }}</span>
                            </div>
                            <div class="flex items-center">
                                <span class="font-semibold text-sm text-gray-600 w-1/2">Number Of Colors</span>
                                <span class="text-gray-700 text-sm w-1/2">{{
                                    GetJobOperationDTO()[0].job_details.noOfColors }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="showOperationReschedule()" class="mb-6 p-4 bg-gray-50 shadow rounded-lg w-1/2">
                        <div class="flex gap-2 rounded-lg p-2 w-fit bg-gray-200">
                            <button class="px-4 py-2 rounded-md text-sm font-medium transition-all" [ngClass]="mode === 'reschdule'
                        ? 'bg-blue-500 text-white shadow'
                        : 'text-gray-600 hover:bg-gray-200'" (click)="mode = 'reschdule'">
                                Operation Reschedule
                            </button>

                            <button class="px-4 py-2 rounded-md text-sm font-medium transition-all" [ngClass]="mode === 'machineChange'
                        ? 'bg-blue-500 text-white shadow'
                        : 'text-gray-600 hover:bg-gray-200'" (click)="mode = 'machineChange'">
                                Machine Change
                            </button>
                        </div>
                        <div *ngIf="mode === 'reschdule'">
                            <div class="pt-4">
                                <div class="flex flex-row pt-4 items-center justify-center">
                                    <h3 class="text-sm font-semibold text-gray-700 w-full w-1/2">New Estimate Date and
                                        Time</h3>
                                    <input type="datetime-local" class="textField flex-1"
                                        [(ngModel)]="newEstimateDateTime" (ngModelChange)="onDateChange()" />
                                </div>
                                <div *ngIf="GetJobOperationDTO()[0].jobStatus === 'hold'"
                                    class="flex flex-row pt-4 items-center justify-center">
                                    <h3 class="text-sm font-semibold text-gray-700 w-full w-1/2">Planned Quantity</h3>
                                    <select class="textField flex-1" [(ngModel)]="selectedPlannedQuantity">
                                        <option [value]="GetJobOperationDTO()[0].quantity">Full Quantity ({{
                                            GetJobOperationDTO()[0].quantity }})</option>
                                        <option
                                            [value]="GetJobOperationDTO()[0].quantity - GetJobOperationDTO()[0].currentNoOfSheets">
                                            Remaining Quantity ({{ GetJobOperationDTO()[0].quantity -
                                            GetJobOperationDTO()[0].currentNoOfSheets }})</option>
                                    </select>
                                </div>
                                <div class="pt-4 max-h-80 overflow-y-auto">
                                    <!-- Occupied Slots with inline free-gap separators -->
                                    <h3 class="text-sm font-semibold text-gray-700 flex items-center gap-2 mb-2">
                                        <svg class="w-3.5 h-3.5 text-gray-500" fill="none" viewBox="0 0 24 24"
                                            stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                        Occupied Slots
                                    </h3>
                                    @let timeline = getMergedTimeline(FilteredOperations(), newEstimateDateTime);
                                    @if (timeline.length > 0) {
                                    <div class="flex flex-col">
                                        @for (item of timeline; track item.startMs) {
                                        @if (item.type === 'free') {
                                        <!-- Free gap separator -->
                                        <div class="flex items-center gap-2 py-0.5 cursor-pointer group"
                                            (click)="selectFreeTimeSlot(item.startFullDateTime)">
                                            <div
                                                class="flex-1 border-t border-dashed border-emerald-300 group-hover:border-emerald-500 transition-colors">
                                            </div>
                                            <span
                                                class="text-[10px] font-medium text-emerald-600 bg-emerald-50 border border-emerald-200 px-1.5 py-0.5 rounded-full whitespace-nowrap group-hover:bg-emerald-100 transition-colors">
                                                {{ item.startTime }} – {{ item.endTime }} &nbsp;·&nbsp; {{
                                                formatHours(item.durationHours) }} free
                                            </span>
                                            <div
                                                class="flex-1 border-t border-dashed border-emerald-300 group-hover:border-emerald-500 transition-colors">
                                            </div>
                                        </div>
                                        } @else {
                                        <!-- Occupied slot row -->
                                        <div class="text-xs text-gray-700 bg-gray-100 border border-gray-200 hover:bg-gray-200 cursor-pointer px-3 py-2 rounded flex items-center justify-between transition-colors my-0.5"
                                            (click)="item.estimatedDateTime && selectTimeSlot(item.estimatedDateTime, item.estimateTime!)">
                                            <div class="flex items-center gap-2">
                                                <span class="w-2 h-2 rounded-full bg-gray-400 shrink-0"></span>
                                                <span class="font-semibold">
                                                    @if (item.jobStatus === 'maintenance scheduled' || item.jobStatus
                                                    === 'maintenance ongoing' || item.jobStatus === 'maintenance
                                                    completed') {
                                                    {{ item.jobStatus === 'maintenance scheduled' ? 'Scheduled Service'
                                                    : item.jobStatus === 'maintenance ongoing' ? 'Ongoing Service' :
                                                    'Maintenance Completed' }}
                                                    } @else {
                                                    {{ item.jobNo }}
                                                    }
                                                </span>
                                                <span class="text-gray-500">{{ item.startTime }} – {{ item.endTime
                                                    }}</span>
                                            </div>
                                            <span
                                                class="text-[10px] text-gray-600 font-medium bg-gray-200 px-1.5 py-0.5 rounded-full">{{
                                                formatHours(item.durationHours) }}</span>
                                        </div>
                                        }
                                        }
                                    </div>
                                    } @else if (newEstimateDateTime) {
                                    <p class="text-xs text-gray-400 mt-1 italic">No operations scheduled for this date.
                                    </p>
                                    } @else {
                                    <p class="text-xs text-gray-400 mt-1 italic">Select a date to view the timeline.</p>
                                    }
                                </div>
                                <div class="pt-4 pb-2">
                                    <div class="flex justify-end space-x-3">
                                        <button type="button" class="button-blue" [disabled]="
                          GetJobOperationDTO()[0].jobStatus !== 'pending' && GetJobOperationDTO()[0].jobStatus !== 'hold' "
                                            (click)="moveOperation(GetJobOperationDTO()[0].id);">
                                            Reschedule
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div *ngIf="mode === 'machineChange'">
                            <div class="flex flex-row pt-4 items-center justify-center mt-4">
                                <h3 class="text-sm font-semibold text-gray-700 w-1/2">Select New Machine</h3>
                                <select id="machine-select" class="textField flex-1 w-1/2" [(ngModel)]="machineId"
                                    (ngModelChange)="onMachineSelect($event)">
                                    <option [ngValue]="null" hidden disabled selected>Choose a Machine</option>
                                    @for (machine of $$filteredMachines(); track machine.machineId) {
                                    <option [ngValue]="machine.machineId">{{ machine.machineName| titlecase }}</option>
                                    }
                                </select>
                            </div>
                            <div class="flex flex-row pt-4 items-center justify-center">
                                <div class="flex flex-col text-gray-700 w-1/2">
                                    <h3 class="font-semibold text-sm">New Estimate Date and Time</h3>
                                    <h3 class="font-medium text-xs">( Suggested available Date and Time )</h3>
                                </div>
                                <input type="datetime-local" class="textField flex-1"
                                    [(ngModel)]="machineChangeEstimateDateTime"
                                    (ngModelChange)="onMachineChangeDateChange()" />
                            </div>
                            <div class="pt-4 max-h-64 overflow-y-auto">
                                <!-- Occupied Slots with inline free-gap separators -->
                                <h3 class="text-sm font-semibold text-gray-700 flex items-center gap-2 mb-2">
                                    <svg class="w-3.5 h-3.5 text-gray-500" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                    Occupied Slots
                                </h3>
                                @let mcTimeline = getMergedTimeline(MachineChangeFilteredOperations(),
                                machineChangeEstimateDateTime);
                                @if (mcTimeline.length > 0) {
                                <div class="flex flex-col">
                                    @for (item of mcTimeline; track item.startMs) {
                                    @if (item.type === 'free') {
                                    <!-- Free gap separator -->
                                    <div class="flex items-center gap-2 py-0.5 cursor-pointer group"
                                        (click)="selectMachineChangeFreeTimeSlot(item.startFullDateTime)">
                                        <div
                                            class="flex-1 border-t border-dashed border-emerald-300 group-hover:border-emerald-500 transition-colors">
                                        </div>
                                        <span
                                            class="text-[10px] font-medium text-emerald-600 bg-emerald-50 border border-emerald-200 px-1.5 py-0.5 rounded-full whitespace-nowrap group-hover:bg-emerald-100 transition-colors">
                                            {{ item.startTime }} – {{ item.endTime }} &nbsp;·&nbsp; {{
                                            formatHours(item.durationHours) }} free
                                        </span>
                                        <div
                                            class="flex-1 border-t border-dashed border-emerald-300 group-hover:border-emerald-500 transition-colors">
                                        </div>
                                    </div>
                                    } @else {
                                    <!-- Occupied slot row -->
                                    <div class="text-xs text-gray-700 bg-gray-100 border border-gray-200 hover:bg-gray-200 cursor-pointer px-3 py-2 rounded flex items-center justify-between transition-colors my-0.5"
                                        (click)="item.estimatedDateTime && selectMachineChangeTimeSlot(item.estimatedDateTime, item.estimateTime!)">
                                        <div class="flex items-center gap-2">
                                            <span class="w-2 h-2 rounded-full bg-gray-400 shrink-0"></span>
                                            <span class="font-semibold">
                                                @if (item.jobStatus === 'maintenance scheduled' || item.jobStatus ===
                                                'maintenance ongoing' || item.jobStatus === 'maintenance completed') {
                                                {{ item.jobStatus === 'maintenance scheduled' ? 'Scheduled Service' :
                                                item.jobStatus === 'maintenance ongoing' ? 'Ongoing Service' :
                                                'Maintenance Completed' }}
                                                } @else {
                                                {{ item.jobNo }}
                                                }
                                            </span>
                                            <span class="text-gray-500">{{ item.startTime }} – {{ item.endTime }}</span>
                                        </div>
                                        <span
                                            class="text-[10px] text-gray-600 font-medium bg-gray-200 px-1.5 py-0.5 rounded-full">{{
                                            formatHours(item.durationHours) }}</span>
                                    </div>
                                    }
                                    }
                                </div>
                                } @else if (machineChangeEstimateDateTime) {
                                <p class="text-xs text-gray-400 mt-1 italic">No operations scheduled for this date.</p>
                                } @else {
                                <p class="text-xs text-gray-400 mt-1 italic">Select a date to view the timeline.</p>
                                }
                            </div>
                            <div class="pt-4 pb-2">
                                <div class="flex justify-end space-x-3">
                                    <button [disabled]="GetJobOperationDTO()[0].jobStatus !== 'pending' && GetJobOperationDTO()[0].jobStatus !== 'hold'" type="button"
                                        class="button-blue" (click)="moveMachine(GetJobOperationDTO()[0].id);">
                                        Change Machine
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="max-h-64 overflow-y-auto scrollbar-hide">
                    <table class="table">
                        <thead class="table-thead">
                            <tr>
                                <th scope="col" class="px-6 py-3">Paused At</th>
                                <th scope="col" class="px-6 py-3">Resume At</th>
                                <th scope="col" class="px-6 py-3">Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                            @if (rescheduledHoldReason()) {
                            <tr class="bg-white border-b">
                                <td class="px-6 py-2 text-sm">{{ rescheduledHoldReason()?.pausedAt | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
                                <td class="px-6 py-2 text-sm">-</td>
                                <td class="px-6 py-2 text-sm">{{ rescheduledHoldReason()?.holdReason }}</td>
                            </tr>
                            }
                            @for (op of GetJobOperationDTO(); track op) {
                            @for (time of op.operation_time; track time.id) {
                            @if (time.reason && time.reason.toLowerCase() !== 'operational') {
                            <tr class="bg-white border-b">
                                <td class="px-6 py-2 text-sm">{{ time.pausedAt | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
                                <td class="px-6 py-2 text-sm">{{ time.resumedAt | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
                                <td class="px-6 py-2 text-sm">{{ time.reason }}</td>
                            </tr>
                            }
                            }
                            } @empty {
                            <tr>
                                <td colspan="12" class="px-6 py-10">
                                    <div class="flex flex-col items-center justify-center text-center">
                                        <p class="text-xl font-semibold text-gray-700 mb-2">No Hold Jobs</p>
                                        <p class="text-gray-500">We couldn't find any paused jobs</p>
                                    </div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
}

@if(modal.$$addServices()){
<div id="add-services-modal" tabindex="-1" aria-hidden="true"
    class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
    <div class="relative p-4 w-full max-w-4xl mx-auto bg-white rounded-lg shadow-lg">
        <div class="relative">
            <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    Add Maintenance / Services
                </h3>
                <button type="button" (click)="modal.$$addServices.set(false)"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <div class="p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Left Column: Form Inputs -->
                <div class="space-y-4">
                    <div>
                        <label class="block mb-2 text-sm font-medium text-gray-900">Machine</label>
                        <input type="text" class="textField w-full bg-gray-100 text-gray-500 cursor-not-allowed"
                            [value]="selectedMachineName() | titlecase" disabled />
                    </div>
                    <div>
                        <label class="block mb-2 text-sm font-medium text-gray-900">Estimated Date & Time</label>
                        <input type="datetime-local" class="textField w-full" [(ngModel)]="maintenanceEstimatedDateTime" (ngModelChange)="onMaintenanceDateChange()" />
                    </div>
                    <div>
                        <label class="block mb-2 text-sm font-medium text-gray-900">Estimate Time (Hours)</label>
                        <input type="number" class="textField w-full" [(ngModel)]="maintenanceEstimateTime"
                            placeholder="e.g. 8" />
                    </div>
                    <div>
                        <label class="block mb-2 text-sm font-medium text-gray-900">Remarks</label>
                        <textarea class="textField w-full" [(ngModel)]="maintenanceRemarks" rows="3"
                            placeholder="Maintenance remarks"></textarea>
                    </div>
                    <div class="flex justify-start pt-2">
                        <button type="button" class="button-blue" (click)="submitMaintenance()">Submit</button>
                    </div>
                </div>

                <!-- Right Column: Timeline -->
                <div class="md:border-l md:border-gray-200 md:pl-6 h-[330px] overflow-y-auto scrollbar-hide">
                    <h3 class="text-sm font-semibold text-gray-700 flex items-center gap-2 mb-2">
                        <svg class="w-3.5 h-3.5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        Occupied Slots
                    </h3>
                    @let maintenanceTimeline = getMergedTimeline(MaintenanceFilteredOperations(), maintenanceEstimatedDateTime);
                    @if (maintenanceTimeline.length > 0) {
                    <div class="flex flex-col">
                        @for (item of maintenanceTimeline; track item.startMs) {
                        @if (item.type === 'free') {
                        <!-- Free gap separator -->
                        <div class="flex items-center gap-2 py-0.5 cursor-pointer group"
                            (click)="selectMaintenanceFreeTimeSlot(item.startFullDateTime)">
                            <div
                                class="flex-1 border-t border-dashed border-emerald-300 group-hover:border-emerald-500 transition-colors">
                            </div>
                            <span
                                class="text-[10px] font-medium text-emerald-600 bg-emerald-50 border border-emerald-200 px-1.5 py-0.5 rounded-full whitespace-nowrap group-hover:bg-emerald-100 transition-colors">
                                {{ item.startTime }} – {{ item.endTime }} &nbsp;·&nbsp; {{
                                formatHours(item.durationHours) }} free
                            </span>
                            <div
                                class="flex-1 border-t border-dashed border-emerald-300 group-hover:border-emerald-500 transition-colors">
                            </div>
                        </div>
                        } @else {
                        <!-- Occupied slot row -->
                        <div class="text-xs text-gray-700 bg-gray-100 border border-gray-200 hover:bg-gray-200 cursor-pointer px-3 py-2 rounded flex items-center justify-between transition-colors my-0.5"
                            (click)="item.estimatedDateTime && selectMaintenanceTimeSlot(item.estimatedDateTime, item.estimateTime!)">
                            <div class="flex items-center gap-2">
                                <span class="w-2 h-2 rounded-full bg-gray-400 shrink-0"></span>
                                <span class="font-semibold">
                                    @if (item.jobStatus === 'maintenance scheduled' || item.jobStatus
                                    === 'maintenance ongoing' || item.jobStatus === 'maintenance
                                    completed') {
                                    {{ item.jobStatus === 'maintenance scheduled' ? 'Scheduled Service'
                                    : item.jobStatus === 'maintenance ongoing' ? 'Ongoing Service' :
                                    'Maintenance Completed' }}
                                    } @else {
                                    {{ item.jobNo }}
                                    }
                                </span>
                                <span class="text-gray-500">{{ item.startTime }} – {{ item.endTime
                                    }}</span>
                            </div>
                            <span
                                class="text-[10px] text-gray-600 font-medium bg-gray-200 px-1.5 py-0.5 rounded-full">{{
                                formatHours(item.durationHours) }}</span>
                        </div>
                        }
                        }
                    </div>
                    } @else if (maintenanceEstimatedDateTime) {
                    <p class="text-xs text-gray-400 mt-1 italic">No operations scheduled for this date.
                    </p>
                    } @else {
                    <p class="text-xs text-gray-400 mt-1 italic">Select a date to view the timeline.</p>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
}

@if(modal.$$cancelMaintenance()){
<div id="cancel-maintenance-modal" tabindex="-1" aria-hidden="true"
    class="fixed inset-0 z-[60] flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
    <div class="relative p-4 w-full max-w-md mx-auto bg-white rounded-lg shadow-lg">
        <div class="relative">
            <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900">
                    Cancel Maintenance
                </h3>
                <button type="button" (click)="modal.$$cancelMaintenance.set(false)"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                </button>
            </div>
            <div class="p-4 space-y-4">
                <div>
                    <label class="block mb-2 text-sm font-medium text-gray-900">Remarks</label>
                    <textarea class="textField w-full" [(ngModel)]="cancelMaintenanceRemarks" rows="3"
                        placeholder="Reason for cancellation (required)"></textarea>
                </div>
                <div class="flex justify-end pt-4 space-x-3">
                    <button type="button"
                        class="bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                        (click)="modal.$$cancelMaintenance.set(false)">Close</button>
                    <button type="button"
                        class="bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                        [disabled]="!cancelMaintenanceRemarks" (click)="submitCancelMaintenance()">Confirm
                        Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>
}

<app-planning-view [machineId]="selectedMachineId()" [machineName]="selectedMachineName()"></app-planning-view>
